import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_RefereeMatches_ActionsMenu_ApiEnum {
    'archive' = 'archive',
}

export enum Config_RefereeMatches_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'matches' = 'matches',
}

export enum Config_RefereeMatches_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_RefereeMatches_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_RefereeMatches_ApiInterface
    extends ConfigDataInterface<
        Config_RefereeMatches_Modules_ApiEnum,
        Config_RefereeMatches_ActionsMenu_ApiEnum,
        Config_RefereeMatches_ActionsOther_ApiEnum,
        Config_Person_PageMenu_ApiEnum,
        Config_RefereeMatches_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
